module.exports = "<a ng-href=\"{{ vm.href }}\" ng-transclude>{{ vm.email }}</a>\n"